import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  RouteEnum,
} from 'app/shared/enums';

export const getEmailTypoMessageKey = (questionKey: string) =>
  getMessageKeyWithSuffix(questionKey, MessagesEnum.TypoInEmailDomain);

const getEmailTypoTargetFromRoute = (): {
  formName: FormsEnum;
  questionKey: FieldsEnum;
} => {
  const isTravel = window.location.pathname.includes(RouteEnum.TRAVEL);
  const isCheckout = window.location.pathname.includes('checkout/');

  if (isTravel) {
    return {
      formName: isCheckout
        ? FormsEnum.TravelCheckoutForm
        : FormsEnum.TravelForm,
      questionKey: isCheckout
        ? FieldsEnum.CheckoutInsurantEmail
        : FieldsEnum.TravelEmailAddress,
    };
  }

  return {
    formName: isCheckout ? FormsEnum.CheckoutForm : FormsEnum.CalculationForm,
    questionKey: isCheckout
      ? FieldsEnum.CheckoutInsurantEmail
      : FieldsEnum.InsurantEmail,
  };
};

export const getEmailTypoTarget = (
  formName?: string,
  questionKey?: string
): { formName: FormsEnum; questionKey: FieldsEnum } => {
  const fallback = getEmailTypoTargetFromRoute();
  const isKnownForm = Object.values(FormsEnum).includes(formName as FormsEnum);
  const isKnownQuestion = Object.values(FieldsEnum).includes(
    questionKey as FieldsEnum
  );

  return {
    formName: isKnownForm ? (formName as FormsEnum) : fallback.formName,
    questionKey: isKnownQuestion
      ? (questionKey as FieldsEnum)
      : fallback.questionKey,
  };
};
